import Data from "../types/Data";
import getAllGroupIds from "./getAllGroupIds";
import getAllGroupsById from "./getAllGroupsById";

export default function getAllGroups(data: Data) {
  const groupIds = getAllGroupIds(data);
  const Group = getAllGroupsById(data);
  return groupIds.map((id) => Group[id]);
}
